export const styles = {
	root: {
		marginRight: '16px'
	},
	buttonSuccess: {
		backgroundColor: 'primary.main',
		'&:hover': {
			backgroundColor: 'primary.main'
		}
	},
	fabProgress: {
		color: 'primary.main',
		position: 'absolute',
		top: 0,
		left: 0,
		zIndex: 1
	},
	button: {
		position: 'relative'
	}
};
